import React from 'react';
import { UserPlus } from 'lucide-react';
import DirectoryManager from '@/components/DirectoryManager';

export default function ReferralDoctorsPage() {
  return (
    <DirectoryManager
      config={{
        title: 'Referral Doctors',
        subtitle: 'External RMPs who refer patients to the hospital. Only active doctors appear in the referral entry form.',
        icon: <UserPlus className="w-6 h-6" />,
        entitySingular: 'Referral Doctor',
        entityPlural: 'Referral Doctors',
        apiPath: '/referral-doctors',
        extraField: {
          key: 'village',
          label: 'Village',
          placeholder: 'e.g. Kannur',
        },
        testIdPrefix: 'referral-doctor',
      }}
    />
  );
}
